import { callApi } from '../../../../apiCaller';
import { toastError } from '../../../../utils';

import { API_SYSTEM_PREVIEW_PDF_SURVEY_REPORTS, API_SYSTEM_SURVEY_REPORTS } from '../../../../constants';
import { setIsLoading } from '../../../../actions/general';
import dayjs from 'dayjs';

export const SURVEY_REPORTS_LIST_SURVEYS = 'surveyReports/listProduct';
export const SURVEY_REPORTS_SURVEY_SELECTED = 'surveyReports/productSelected';
export const SURVEY_REPORTS_USER_RESULTS = 'surveyReports/userResults';
export const SURVEY_REPORTS_PREVIEW_PDF_RESULTS = 'surveyReports/previewPdf';
export const SURVEY_REPORTS_SELECTED_START_DATE = 'surveyReports/selectedStartDate';
export const SURVEY_REPORTS_SELECTED_END_DATE = 'surveyReports/selectedEndDate';
export const SURVEY_REPORTS_LIST_EVENT = 'surveyReports/listEvent';
export const SURVEY_REPORTS_LIST_EVENT_SELECTED = 'surveyReports/listEventSelected';

export const API_SYSTEM_ADMIN_LIST_SURVEYS_REPORT = 'survey-reports/surveys';
export const API_SYSTEM_ADMIN_LIST_EVENTS_REPORT = 'survey-reports/events';

export const setUserSurveyResultsReport = (userSurveyResults) => {
     return {
          type: SURVEY_REPORTS_USER_RESULTS,
          payload: userSurveyResults,
     };
};
export const setPreviewPdfSurveyResultsReport = (userSurveyResults) => {
     return {
          type: SURVEY_REPORTS_PREVIEW_PDF_RESULTS,
          payload: userSurveyResults,
     };
};

const setListSurveyOptions = (surveys) => {
     return {
          type: SURVEY_REPORTS_LIST_SURVEYS,
          payload: surveys,
     };
};

export const setListEventProductSurveyReports = (events) => {
     return {
          type: SURVEY_REPORTS_LIST_EVENT,
          payload: events,
     };
};

export const setSurveySelectedOptions = (productId) => {
     return {
          type: SURVEY_REPORTS_SURVEY_SELECTED,
          payload: productId,
     };
};

export const setSelectedStartDate = (date) => {
     return {
          type: SURVEY_REPORTS_SELECTED_START_DATE,
          payload: date,
     };
};

export const setSelectedEndDate = (date) => {
     return {
          type: SURVEY_REPORTS_SELECTED_END_DATE,
          payload: date,
     };
};

export const fetchListSurveyOptions = () => (dispatch) => {
     dispatch(setIsLoading(true));

     callApi(API_SYSTEM_ADMIN_LIST_SURVEYS_REPORT, 'GET')
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               const surveys = response.data.map((survey) => ({
                    value: survey.id,
                    label: survey.name,
                    haveEvent: survey.haveEvent,
               }));

               dispatch(setListSurveyOptions(surveys));
          })
          .finally(() => {
               dispatch(setIsLoading(false));
          });
};
export const fetchListEventOptions = (surveyFilter, setDisableEvent, setEventOptions, start, end) => (dispatch) => {
     setDisableEvent(true);

     callApi(`${API_SYSTEM_ADMIN_LIST_EVENTS_REPORT}?surveyId=${surveyFilter}&startDate=${start}&endDate=${end}`, 'GET')
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               const events = response.data
                    .filter((event) => event.startAt)
                    .map((event) => ({
                         value: event.id,
                         label: event.name || dayjs(event.startAt).format('MMM DD, YYYY h:mmA'),
                         startAt: event.startAt,
                    }))
                    .sort((a, b) => {
                         if (a.startAt === null && b.startAt === null) {
                              return 0;
                         } else if (a.startAt === null) {
                              return 1;
                         } else if (b.startAt === null) {
                              return -1;
                         }
                         return new Date(b.startAt) - new Date(a.startAt);
                    });

               setEventOptions(events);
          })
          .finally(() => {
               setDisableEvent(false);
          });
};

export const fetchUserSurveyResultsReport = (dataFilterSurveyReport) => (dispatch) => {
     dispatch(setIsLoading(true));
     const { surveyId, startDate, endDate, listEventSelected } = dataFilterSurveyReport;
     const endpoint = `${API_SYSTEM_SURVEY_REPORTS}?surveyId=${surveyId}&startDate=${startDate}&endDate=${endDate}&listEventSelected=${listEventSelected}`;

     callApi(endpoint, 'GET')
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               dispatch(setUserSurveyResultsReport(response.data));
          })
          .finally(() => {
               dispatch(setIsLoading(false));
          });
};

export const previewPdfSurveyResultsReport = (setPreviewPdf, setIsLoadingPdf, dataFilterSurveyReport) => (dispatch) => {
     setIsLoadingPdf(true);
     const { surveyId, startDate, endDate, listEventSelected } = dataFilterSurveyReport;

     const endpoint = `${API_SYSTEM_PREVIEW_PDF_SURVEY_REPORTS}?surveyId=${surveyId}&startDate=${startDate}&endDate=${endDate}&listEventSelected=${listEventSelected}`;

     callApi(endpoint, 'GET')
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               dispatch(setPreviewPdfSurveyResultsReport(response.data));
          })
          .finally(() => {
               setIsLoadingPdf(false);
               setPreviewPdf(true);
          });
};
